import { render, staticRenderFns } from "./top-left.vue?vue&type=template&id=4ef48888&scoped=true&"
import script from "./top-left.vue?vue&type=script&lang=js&"
export * from "./top-left.vue?vue&type=script&lang=js&"
import style0 from "./top-left.vue?vue&type=style&index=0&id=4ef48888&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef48888",
  null
  
)

export default component.exports